import * as React from "react";
import { Card } from "antd";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { Secret } from "../../schema/types/secret/entity";
import { CardContent } from "../../components/antd/card/CardContent";
import { DetectedTags } from "../../components/detail/detectedTags";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { FormLabel } from "../../components/antd/form/FormLabel";

interface Props {
  secret: Secret;
}
export const Summary: React.FC<Props> = ({ secret }) => {
  const hasTagLinks =
    Object.entries(secret.tags || {}).filter(([_, value]) =>
      tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
    ).length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            <DetectedTags
              value={secret.tags}
              detectValue={(tags, key) => tags.hasOwnProperty(key)}
              detectionMap={{
                "syncer.cpln.io/source": "Link to ESS parent of the secret",
                "syncer.cpln.io/lastError": "The last error found when syncing secrets",
              }}
              pluralLabel="Tags"
            />
            {hasTagLinks ? (
              <TagLinksTable
                tableId="secret-info-tag-links"
                tags={Object.entries(secret.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
